"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    collapsedGroups: ['before_fb', 'after_fb'],
    items: [1, 2, 3, 4],
    itemsById: {
      1: {
        id: 1,
        link: '#',
        img: 'https://placehold.it/270x450',
        alt: '270x450',
        text: '',
        heading: '',
        btn: '',
        collapsed: false,
        type: 'banner',
        position: 'before_fb'
      },
      2: {
        id: 2,
        link: '#',
        img: 'https://placehold.it/270x270',
        alt: '270x270',
        text: '',
        heading: '',
        btn: '',
        collapsed: false,
        type: 'banner',
        position: 'after_fb'
      },
      3: {
        id: 3,
        link: '#',
        img: '',
        alt: '',
        text: '<p>Custom block displayed at the left sidebar. You can put your own content here: text, html, images, media... whatever you like.</p><p>Here are many similar sample content placeholders across the store. All editable from admin panel.</p>',
        heading: 'Custom Block',
        btn: 'Sample Button',
        collapsed: true,
        type: 'text_block',
        position: 'after_fb'
      },
      4: {
        id: 4,
        link: '#',
        img: 'https://placehold.it/270x450',
        alt: '270x450',
        text: '',
        heading: '',
        btn: '',
        collapsed: true,
        type: 'banner',
        position: 'after_fb'
      }
    },
    itemNextId: 5
  };
}